module.exports = __webpack_public_path__ + "img/icon_audio@2x.49460fec.png";